import {
  MDBBtn,
  MDBChip,
  MDBChipsInput,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import {
  getIsFeatureExist,
  getMisc,
} from "../../../apiclients/streamsapi_bridge";
import AddNumbersStatic from "../../../views/popups/phonenumbers/AddNumbersStatic";
import PopupLoader from "../../../views/popups/PopupLoader";
import {
  formattedNumber,
  unFormatNumber,
} from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import SendFax from "../../editviews/user/SendFax";
import { show_links_tab } from "../../../apiclients/apiurls";
import FeatureWarning from "../editUtils/FeatureWarning";
function UserFax({
  register,
  setValue,
  errors,
  getValues,
  setSuccessMessage,
  watch,
  faxPhoneNum,
  useragent,
  setError,
  clearErrors,
  faxDomain,
  isstreamsReq,
  faxPhoneError,
  setfaxPhoneError,
  faxEnabledFlag,
  setIsloading,
}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [addNumbers, setAddNumbers] = useState(false);
  const toggleNumbers = () => setAddNumbers(!addNumbers);
  const [callerids, setCallerids] = useState([]);
  const [sourceNumber, setSourceNumber] = useState([]);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [faxPhoneNums, setFaxPhoneNums] = useState([]);
  const [existFaxPhoneNums, setExistFaxPhoneNums] = useState([]);
  const [removePHNum, setRemovePHNum] = useState([]);
  const [addPHNum, setAddPHNum] = useState([]);
  const [useraddednumbers, setUserAddedNumbers] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(true);
  const [finaladdlist, setFinalAddList] = useState([]);
  const [finalremovedlist, setFinalRemovedList] = useState([]);
  const [editFaxWarning, seteditFaxWarning] = useState(false);
  const faxWarningToggle = () => seteditFaxWarning(!editFaxWarning);
  const [warningMessage, setwarningMessage] = useState("");

  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["callerid_list"], agentid: useragent }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    setCallerids(tdata?.misc?.callerid_list ?? []);
  }

  useEffect(() => {
    if (useragent !== "") {
      fetchData();
    }
  }, [useragent]);

  useEffect(() => {
    if (freePhoneFlag) {
      getFreePhoneNumbers();
      setfreePhoneFlag(false);
    }
  }, [freePhoneFlag]);

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["free_dids"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      //navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    setSourceNumber(basicInfo.misc.free_dids);
  }

  useEffect(() => {
    if (
      (removePHNum.length > 0 || addPHNum.length > 0) &&
      !updateNumbersExecuted
    ) {
      updateAddedNumbers();
      setUpdateNumbersExecuted(true);
    }
  }, [addPHNum, removePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (faxPhoneNum) {
      setFaxPhoneNums(faxPhoneNum);
      setExistFaxPhoneNums(faxPhoneNum);
      setAddPHNum(faxPhoneNum);
      setUserAddedNumbers(faxPhoneNum);
    }
  }, [faxPhoneNum]);

  useEffect(() => {
    if (faxPhoneError) {
      setfaxPhoneError(false);
      setFaxPhoneNums(faxPhoneNum);
      setExistFaxPhoneNums(faxPhoneNum);
      setAddPHNum(faxPhoneNum);
      setUserAddedNumbers(faxPhoneNum);
    }
  }, [faxPhoneError]);

  function updateAddedNumbers() {
    clearErrors("fax.add_dids");
    const updatenum = addPHNum.filter(
      (number) => !useraddednumbers.includes(number)
    );
    setFinalAddList(updatenum);
    setValue("fax.add_dids", updatenum, { shouldDirty: true });
    setFaxPhoneNums(addPHNum);
    setAddPHNum(addPHNum);
    const finalremoved = removePHNum.filter((num) =>
      useraddednumbers.includes(num)
    );
    setFinalRemovedList(finalremoved);
    setValue("fax.remove_dids", finalremoved, { shouldDirty: true });
    clearErrors("fax.add_dids");
    clearErrors("fax.primary_did");
  }
  const handleDelete = (num) => {
    clearErrors("fax.add_dids");
    const number = unFormatNumber(num);
    const updateAddPHNum = addPHNum.filter((addNum) => addNum !== number);
    setFaxPhoneNums(updateAddPHNum);
    setAddPHNum(updateAddPHNum);

    // Add the deleted number to removePHNum
    setRemovePHNum((prevRemovePHNum) => [...prevRemovePHNum, number]);
    // Filter out the removed number from grpaddednumbers and setFinalRemovedList
    let finalremoved = useraddednumbers.filter((num) => num === number);
    const oldRemove = watch("fax.remove_dids");
    finalremoved = [...oldRemove, ...finalremoved];

    setFinalRemovedList(finalremoved);
    setValue("fax.remove_dids", finalremoved, { shouldDirty: true });
    const oldadd = watch("fax.add_dids");
    const updatenum = oldadd.filter((num) => num !== number);
    setFinalAddList(updatenum);
    setValue("fax.add_dids", updatenum, { shouldDirty: true });
  };

  const [fullscreenXlModal, setFullscreenXlModal] = useState(false);

  // const sendFaxPopup = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   if (existFaxPhoneNums && existFaxPhoneNums.length > 0) {
  //     setModalKey((prev) => prev + 1);
  //     setFullscreenXlModal(!fullscreenXlModal);
  //   } else {
  //     alert("You do not have this feature.");
  //   }
  // };

  const sendFaxPopup = (e) => {
    e.preventDefault();
    if (existFaxPhoneNums && existFaxPhoneNums.length > 0) {
      const faxParams = {
        faxNumbers: faxPhoneNums,
        uniqueid: useragent,
        faxDomain: faxDomain,
        primaryFax: watch("fax.primary_did") || "",
        isActive: "tab1",
      };
      localStorage.setItem("faxParams", JSON.stringify(faxParams));

      window.open(`/send-fax`, "_blank");
    } else {
      alert("You do not have this feature.");
    }
  };

  useEffect(() => {
    if (
      faxPhoneNums &&
      faxPhoneNums.length > 0 &&
      (!existFaxPhoneNums || existFaxPhoneNums.length === 0)
    ) {
      setValue("fax.primary_did", faxPhoneNums[0] + "", {
        shouldDirty: true,
      });
    }
  }, [faxPhoneNums]);

  async function handleIsAddonExist() {
    setIsloading(true);
    // 73 fax addon id
    let saverep = await getIsFeatureExist(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      useragent,
      73
    );
    setValue("fax_enable", true, {
      shouldDirty: true,
    });
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    console.log(`reponse of getIsFeatureExist :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of getIsFeatureExist :::" + JSON.stringify(saverepeMsg)
    );

    if (saverepeMsg.status && saverepeMsg.status == "success") {
      const errorMessage = saverepeMsg.message;
      if (errorMessage && errorMessage !== "") {
        setwarningMessage(saverepeMsg.message);
        faxWarningToggle();
      }
    }
  }

  const handleOk = (e) => {
    e?.preventDefault();
    setValue("fax_enable", false, {
      shouldDirty: true,
    });
    faxWarningToggle();
  };

  return (
    <>
      <div className="general-settings" id="Fax">
        Fax
      </div>
      <div className="ps-0">
        <div
          {...(isstreamsReq
            ? {
                title: "User does not have permission to edit",
                className: "disabled-form cursor-notAllowed",
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                },
              }
            : {})}
        >
          <div className="add-numbermain">
            <div className="tel-numbers">{t("EnableFax")}</div>
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  checked={watch("fax_enable")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    if (isChecked && faxEnabledFlag !== isChecked) {
                      handleIsAddonExist();
                    } else {
                      setValue("fax_enable", isChecked, { shouldDirty: true });
                    }
                  }}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>

        {watch("fax_enable") && (
          <div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("SendaFax")}</div>
              <MDBBtn onClick={sendFaxPopup}>
                <MDBIcon far icon="paper-plane" className="me-2" /> Send Fax
              </MDBBtn>
            </div>
            <div
              {...(isstreamsReq
                ? {
                    title: "User does not have permission to edit",
                    className: "disabled-form cursor-notAllowed",
                    onClick: (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    },
                  }
                : {})}
            >
              <div className="add-numbermain">
                <div className="tel-numbers">{t("name")}</div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <input
                      maxLength={50}
                      type="text"
                      {...register(
                        "fax.name"
                        //   , {
                        //   required: "Fax name is required",
                        // }
                      )}
                      className="selectname w-100"
                    />
                    {errors.fax?.name && (
                      <p className="text-danger">{errors.fax?.name.message}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="add-numbermain">
                <div className="tel-numbers">{t("telephone_Numbers")}</div>
                <MDBBtn
                  className="mb-2"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleNumbers();
                  }}
                >
                  <MDBIcon fas icon="plus" size="sm" /> {t("add_Numbers")}
                </MDBBtn>
              </div>
              <div style={{ paddingLeft: "7px", paddingRight: "7px" }}>
                <div className="chips chips-placeholder">
                  {faxPhoneNums &&
                    faxPhoneNums.length > 0 &&
                    faxPhoneNums.map((phone) => (
                      <>
                        <span
                          {...(isstreamsReq
                            ? {
                                title: "User does not have permission to edit",
                                className: "disabled-form cursor-notAllowed",
                                onClick: (e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                },
                              }
                            : {})}
                        >
                          <MDBChip
                            className="m-chip d-inline py-2 px-3"
                            label="Example label"
                            {...(!isstreamsReq
                              ? {
                                  onDelete: () => handleDelete(phone),
                                  closeIcon: true,
                                }
                              : {})}
                            key={phone}
                            size="sm"
                          >
                            {formattedNumber(phone)}
                          </MDBChip>
                        </span>
                      </>
                    ))}
                </div>
              </div>
              {errors?.fax?.add_dids && (
                <p className="text-danger text-end">
                  {errors.fax.add_dids.message}
                </p>
              )}
              <div className="add-numbermain">
                <div className="tel-numbers">{"Email Address"}</div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <input
                      type="text"
                      className="selectname w-100"
                      {...register(
                        "fax.email"
                        // , {
                        // required: "Email ID is required",
                        // pattern: {
                        //   value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        //   message: "Invalid email address",
                        // },
                        // }
                      )}
                    />
                    {errors?.fax?.email && (
                      <p className="text-danger">{errors.fax.email.message}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="add-numbermain">
                <div className="tel-numbers">{t("Primary Fax Number")}</div>
                <div className="phoneselect w-30">
                  <select
                    className="form-control form-select selectname w-100"
                    name="San Jose"
                    value={watch("fax.primary_did")}
                    // {...register("fax.default_cid", {
                    //   required: "Select Callerid",
                    // })}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        setError("fax.primary_did", {
                          message: "Select Primary did",
                        });
                      } else {
                        clearErrors("fax.primary_did");
                      }
                      setValue("fax.primary_did", e.target.value, {
                        shouldDirty: true,
                      });
                    }}
                  >
                    {/* <option value="">--Select Default Callerid--</option> */}
                    {faxPhoneNums &&
                      faxPhoneNums.length > 0 &&
                      faxPhoneNums.map((num) => (
                        <>
                          <option key={num} value={num}>
                            {num}
                          </option>
                        </>
                      ))}
                  </select>
                  {errors?.fax?.primary_did && (
                    <p className="text-danger text-end">
                      {errors.fax.primary_did.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {addNumbers && (
        <PopupLoader
          // size="lg"
          // className="modal-lg"
          title={"Add Numbers"}
          content={
            <AddNumbersStatic
              selectedNum={faxPhoneNums}
              setaddPHNum={setAddPHNum}
              removePHNum={removePHNum}
              setRemovePHNum={setRemovePHNum}
              setUpdateNumbersExecuted={setUpdateNumbersExecuted}
              sourceNumber={sourceNumber}
              onClose={toggleNumbers}
            />
          }
          onShow={setAddNumbers}
          onClose={toggleNumbers}
        />
      )}

      {/* <MDBModal
        tabIndex="-1"
        key={modalKey}
        open={fullscreenXlModal}
        onClose={() => setFullscreenXlModal(false)}
      >
        <MDBModalDialog size="fullscreen">
          <MDBModalContent className="h-100">
            <MDBModalHeader>
              <MDBModalTitle>Send Fax</MDBModalTitle>
              <MDBBtn
                type="button"
                className="btn-close"
                color="none"
                onClick={sendFaxPopup}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className="sendafaxPopupBody">
              <MDBContainer fluid>
                <div className="m-auto">
                  <SendFax
                    faxPhoneNums={faxPhoneNums}
                    uniqueid={useragent}
                    faxDomain={faxDomain}
                    primaryFax={watch("fax.primary_did")}
                    groupFaxFlag={false}
                    userList={null}
                    isActive="tab1"
                  />
                </div>
              </MDBContainer>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn type="button" color="secondary" onClick={sendFaxPopup}>
                Close
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal> */}
      {editFaxWarning && (
        <PopupLoader
          size="md"
          className="modal-xl modal-auto"
          title="Alert"
          content={
            <FeatureWarning warningMessage={warningMessage} onOk={handleOk} />
          }
          onShow={seteditFaxWarning}
          onClose={handleOk}
        />
      )}
    </>
  );
}

export default UserFax;
